'use client';

import OrderDetails from '../order-details/order-details';
import { ProductConfiguration } from '../product-configuration/product-configuration';

export default function ConfigurationWrapper() {
  return (
    <>
      <ProductConfiguration />
      <OrderDetails />
    </>
  );
}
